import React from "react";
import {
  HorizontalCheckboxButton,
  HorizontalCheckboxCheck,
  HorizontalCheckboxGroupWrapper,
  HorizontalCheckboxLabel,
} from "./styled";

const HorizontalCheckboxGroup = (props) => {
  const {
    options = [],
    checkedValue,
    onChange,
    disabled = false,
    error = null,
  } = props;

  return (
    <HorizontalCheckboxGroupWrapper>
      {options.map((option, index) => {
        let { label, value, setDisabled = false } = option;

        if (typeof option === "string") {
          label = option;
          value = option;
        }

        const optionValue = value?.length ? value : label;
        const checked =
          typeof checkedValue === "boolean"
            ? checkedValue
            : checkedValue?.includes(optionValue);

        return (
          <HorizontalCheckboxButton
            key={`horizontal-checkbox-${index}`}
            type="button"
            role="checkbox"
            aria-checked={checked}
            disabled={disabled || setDisabled}
            selected={checked}
            error={error}
            onClick={() => onChange(optionValue)}
          >
            <HorizontalCheckboxCheck
              aria-hidden="true"
              selected={checked}
              disabled={disabled || setDisabled}
              error={error}
            >
              {checked ? <em className="far fa-check" /> : null}
            </HorizontalCheckboxCheck>
            <HorizontalCheckboxLabel>{label}</HorizontalCheckboxLabel>
          </HorizontalCheckboxButton>
        );
      })}
    </HorizontalCheckboxGroupWrapper>
  );
};

export default HorizontalCheckboxGroup;
